export default __webpack_public_path__ + "static/media/payment-failed.ba4b87b6.svg";